<template src='./DatosInicioSeguimiento.html'>
</template>
<script>
import Vue from 'vue'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import ComponenteSelect from '../../ComponenteSelect/ComponenteSelect'
import {serverBus} from '../../../main'
import { actualizarFormulario } from '../../../apiService/request/CrudFormulario';
// import { actualizarFormulariosExistentes } from '../../../apiService/request/CrudFormulario'
Vue.use(VueMaterial)
export default {
  data() {
    return {
       arrayElementoSeleccionado: []
    }
  },
  
  mounted(){
    serverBus.$on('jsonSeleccion',(jsonSeleccion) =>{
      this.seleccionSeguimientos(jsonSeleccion);
    });
  },
  beforeDestroy() {
    serverBus.$off('jsonSeleccion')
  },
  beforeUpdate(){
  },
  props:{
      formularioSeguimiento: Object,
      idFormularioSeguimiento: String
  },
  components: {
    ComponenteSelect
  },
  methods:{
    seleccionSeguimientos (jsonSeleccion) { 
      const {nombre_campo,valor,index} = jsonSeleccion
      const result = this.arrayElementoSeleccionado.filter(elemento => elemento.nombre_campo == nombre_campo)
      if(result.length >= 1){
        this.arrayElementoSeleccionado[index].valor = valor
        this.actualizarFormulario()
      }else{    
        this.arrayElementoSeleccionado.push({nombre_campo, valor,'nombre':'variable'+(index+1)})
        this.actualizarFormulario()
      }
    },
    async actualizarFormulario(){
      try {
          if(this.arrayElementoSeleccionado.length==this.formularioSeguimiento.variables.length){
            const respuesta = await actualizarFormulario(this.idFormularioSeguimiento,this.formularioSeguimiento.key, this.arrayElementoSeleccionado, 'formularios',this.$store.state.provider_email)
          }
      }
      catch (err){
      }
    },
  },

}
</script>
<style lang="scss" scoped src='./DatosInicioSeguimiento.css'>
</style>



// WEBPACK FOOTER //
// src/components/Seguimiento/DatosInicioSeguimiento/DatosInicioSeguimiento.vue